import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
import { Card, CardContent, CardHeader } from '@material-ui/core';



const CartLeadsInByTime = props => {
  const { series = [], categories = [], title, subheader } = props;




  const cartData = {
    options: {
      chart: {
        type: 'line',
        id: "CartLeadsInByTime",

      },
      xaxis: {
        categories: categories
      }
    },
    series: series
  };


  return (categories && series) ?
    <Card>
      <CardHeader 
      title={title} 
      subheader={subheader}>
        
      </CardHeader>
      <CardContent>
        <ReactApexChart
          type="line"
          options={cartData.options}
          series={cartData.series}
          height={350} />
      </CardContent>
    </Card> : <>loading</>

};

CartLeadsInByTime.propTypes = {
  series: PropTypes.array,
  categories: PropTypes.array,
};

export default CartLeadsInByTime;
